import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const verifyAdmin = (admin_key) => api.post("/admin/verify", { admin_key }).then((r) => r.data);
export const fetchLeads = (key) =>
  api.get("/admin/leads", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const fetchStats = (key) =>
  api.get("/admin/stats", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const deleteLead = (id, key) =>
  api.delete(`/admin/leads/${id}`, { headers: { "X-Admin-Key": key } }).then((r) => r.data);
